import { initGame } from './actions'

export default function init(dispatch) {
  return new Promise(resolve => {
      dispatch(initGame())
      resolve()
    })
}



// WEBPACK FOOTER //
// ./src/core/app/init.js